import React from 'react';
import { ResponsiveContext, Box, Text } from 'grommet';

export const Tag = (props) => {
  const {
    text = 'Undefined',
    background = 'dark-5',
    textColor = 'white',
    textSize = 'small',
  } = props;

  return (
    <ResponsiveContext.Consumer>
      {size => (
        <Box
          background={background}
          round='medium'
          pad={{
            horizontal: size === 'small' ? 'small' : 'xsmall',
            vertical: size === 'small' ? 'xxsmall' : 'none',
          }}
        >
          <Text
            title={text}
            truncate
            color={textColor}
            size={textSize}
          >
            {text}
          </Text>
        </Box>
      )}

    </ResponsiveContext.Consumer>
  )
}
